export default "__VITE_ASSET__Dzj2Xtmh__"